<!--中国石化电商支付平台服务规则-->
<template>
  <e-dialog
    dialog-title="中国石化电商支付平台服务规则"
    :center-dialog-visible="visible"
    :popup-width="'900px'"
    :show-btn="false"
    :show-close-btn="true"
    @resetPopupData="visible = false"
  >
    <div class="rules-container">
      <h2>中国石化电商支付平台服务规则</h2>
      <p>
        中国石化电商支付平台（以下简称“支付平台”）是中国石化所属电商平台与合作银行共同搭建的为会员提供银行账户开立、支付指令交互、交易资金结算、支付信息查询等功能和服务的平台。会员使用支付平台相关服务过程中，应遵守国家有关法律法规、合作银行和电商平台的相关规章制度、管理要求以及本服务规则。
      </p>
      <p>
        一、会员应仔细阅读电商平台注册会员服务协议、账户管理、交易支付等规则。会员提交银行支付账户开户申请时，即视同已了解并承诺遵守合作银行、电商平台关于账户管理、交易支付等相关规定。
      </p>
      <p>
        二、支付账户开立后，会员须使用绑定的同名银行账户向支付账户完成小额资金转账，进行鉴权操作激活支付账户。会员支付账户只能用于中国石化所属电商平台上的交易资金结算，不得直接作为收付款信息和渠道对外公布和使用。
      </p>
      <p>
        三、会员须使用电商平台提供的UKEY登录支付平台进行相关业务操作，并负有妥善保管UKEY、用户密码、开户信息等义务。如有遗失、被盗，会员应及时申请挂失，挂失手续办妥前发生的风险和损失由会员自行承担。
      </p>
      <p>
        四、会员须按照合作银行、电商平台有关支付结算规定和要求，自行提交支付指令进行交易资金结算。支付平台只负责电商平台和合作银行间支付信息的传递，并向会员提供银行支付账户交易明细、余额等信息的查询，以及合作银行提供的回单打印服务。
      </p>
      <p>
        五、当交易存在异常或风险，合作银行和电商平台采取止付交易款项、暂停或停止提供服务时，支付平台也相应采取措施停止服务。
      </p>
      <p>
        六、支付平台营业时间为每日2:00-23:30
        ，非营业时间会员无法登录，也不接受电商平台支付指令。营业时间内，仅工作日的9:00-16:30可以进行担保支付、收货确认和出金等支付类操作,其他时间段只能进行查询类操作。
      </p>
      <p>
        七、支付平台有权对本规则进行变更，并在支付平台上进行公告，变更内容自公告之日起生效，无需对会员另行单独通知。会员若在公告之后继续使用本服务的，表示已充分阅读、理解并接受修改后的内容，否则应立即停止使用相关服务。
      </p>
    </div>
  </e-dialog>
</template>

<script>
import EDialog from '../../../components/common/e-dialog.vue';

export default {
  name: 'PlatformRules',
  components: { EDialog },
  data() {
    return {
      visible: false,
    };
  },
  created() {},

  methods: {
    initData() {
      this.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.rules-container {
  h2 {
    text-align: center;
    font-size: 30px;
    color: #333;
  }
  p {
    text-align: justify;
    text-indent: 2em;
    margin-bottom: 10px;
  }
}
</style>
